export default __webpack_public_path__ + "static/media/border.95423b8d.svg";